<template>
  <div :class="$style.grid_editor_container">
    <grid-input
      ref="inputEditor"
      :value="value"
      type="text"
      text-align="start"
      :initial-select="false"
      :keep-focus="false"
      @onInput="onInput"
    />

    <div
      :class="$style.grid_editor_date"
      :style="{
        top: coordinates.top,
        left: coordinates.left,
      }"
    >
      <vgp-date-picker
        :time-picker="true"
        :value="datePickerValue"
        :start-or-end="column.name"
        :work-days="workDays"
        :min-date="minDate"
        :calendar-config="calendarConfig"
        @onChange="onSelectDate"
        @onChangeTime="onSelectDate"
      >
        <template #footer="{ setValue }">
          <button
            v-if="!!todayDate"
            :class="'time-picker_label'"
            @click.stop="() => setValue(todayDate)"
          >
            {{ locales('datepiker_today') }}
          </button>
        </template>
      </vgp-date-picker>
    </div>
  </div>
</template>

<script>
import GridInput from '../components/input.vue';
import vgpDatePicker from '$$vueCmp/datePicker/vgpDatePicker.vue';

export default {
  name: 'GridDateCellEditor',
  components: { GridInput, vgpDatePicker },
  props: {
    placeholder: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
    workDays: {
      type: Array,
      required: true,
    },
    calendarConfig: {
      type: Object,
      default: null,
    },
    minDate: {
      type: Date,
      default: null,
    },
    todayDate: {
      type: Date,
      default: null,
    },
    onSave: {
      type: Function,
      required: true,
    },
    onCancel: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      value: null,
      datePickerValue: null,
      locales: __,
      coordinates: {
        left: 'auto',
        top: 'auto',
      },
    };
  },
  created() {
    this.calcCoordinates();
  },
  mounted() {
    this.placeholder.addEventListener('wheel', this.onScrollPlaceholder, { passive: true });
    document.addEventListener('keydown', this.onKeyDown);
  },
  beforeUnmount() {
    this.placeholder.removeEventListener('wheel', this.onScrollPlaceholder);
    document.removeEventListener('keydown', this.onKeyDown);
  },
  methods: {
    calcCoordinates() {
      const placeholderRect = this.placeholder.getBoundingClientRect();
      const gridResizerRect = document.querySelector('.gantt_layout_cell.gantt_resizer_x').getBoundingClientRect();
      const clientHeight = document.documentElement.clientHeight;
      const elementHeight = 310, elementWidth = 258;
      let coords = { top: 0, left: 0 };

      const dropToBottom = (placeholderRect.bottom + elementHeight) < clientHeight;

      if (dropToBottom) {
        coords = {
          top: `${placeholderRect.bottom + 1}px`,
          left: `${placeholderRect.left}px`,
        };
      } else {
        coords = {
          top: `${placeholderRect.top - elementHeight - 2}px`,
          left: `${placeholderRect.left}px`,
        };
      }

      if (gridResizerRect.right < placeholderRect.left + elementWidth) {
        coords.left = `${placeholderRect.right - elementWidth - 2}px`;
      }

      this.coordinates = coords;
    },

    onInput(val) {
      this.value = val;
    },

    onSelectDate(newValue) {
      this.value = newValue;
      this.onSave();
    },

    onScrollPlaceholder(event) {
      // stop event bubbling to allow scrolling inside editor
      event.stopPropagation();
    },

    onKeyDown(event) {
      if (event.keyCode === 13) { // enter
        this.onSave();
      }

      if (event.keyCode === 27) { // esc
        this.onCancel();
      }
    },
  },
};
</script>

<style module src="../styles/gridEditor.less" lang="less"></style>
